var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-icon",class:( _obj = {}, _obj[(_vm.color + "--text")] = true, _obj['mx-auto'] =  _vm.center, _obj )},[(_vm.icon === 'success')?_c('success-icon'):(_vm.icon === 'info')?_c('info-icon'):(_vm.icon === 'error')?_c('error-icon'):_c('v-icon',{attrs:{"color":_vm.color,"size":"60"}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }